import {
  mapGetters,
} from 'vuex'

export default {
  computed: {
    ...mapGetters(['statusList']),
  },
  methods: {
    getStatusDetails(key) {
      const obj = this.statusList.find(n => n.key === key)
      return obj ? obj.color : '#fffff'
    },
    getLightBackground(hex) {
      if (/^#[0-9A-F]{6}$/i.test(hex)) {
        const r = parseInt(hex.substr(1, 2), 16)
        const g = parseInt(hex.substr(3, 2), 16)
        const b = parseInt(hex.substr(5, 2), 16)
        return `rgba(${r}, ${g}, ${b}, 0.12)` // 12% opacity for soft bg
      }
      return 'rgba(0,0,0,0.07)' // fallback
    },
  },
}
